import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import {
  AppointmentTimes,
  AppointmentType,
  DateAndType,
  ListItem,
  ListItemContent,
  ListItemFooter,
  ListItemHover,
  ListItemTitle,
  ListItemWrapper,
  PatientName,
  RequestComment,
  RequestDate,
  RequestType,
  StatusIcons,
  StatusMessage
} from './appt-request-list-item.styles';

export const ApptRequestListItemSkeleton: FC = () => {
  return (
    <ListItemWrapper>
      <ListItemHover isdirectbooking="false" sx={{ padding: '12px 0px 12px 12px' }}>
        <ListItem>
          <ListItemTitle>
            <PatientName>
              <Skeleton variant="text" width={120 + Math.random() * 50} height={22} />
            </PatientName>
            <DateAndType sx={{ alignItems: 'end' }}>
              <RequestDate>
                <Skeleton variant="text" width={70} height={12} />
              </RequestDate>
              <RequestType>
                <Skeleton variant="text" width={90} height={12} />
              </RequestType>
            </DateAndType>
          </ListItemTitle>
          <ListItemContent>
            <Box sx={{ flexDirection: 'column', display: 'flex' }}>
              <AppointmentType>
                <Skeleton variant="text" width={90 + Math.random() * 60} height={14} />
              </AppointmentType>
              <AppointmentTimes>
                <Skeleton variant="text" width={130 + Math.random() * 40} height={14} />
              </AppointmentTimes>
              <RequestComment>
                <Skeleton variant="text" width={80 + Math.random() * 50} height={14} />
              </RequestComment>
            </Box>
          </ListItemContent>
          <ListItemFooter>
            <StatusMessage sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
              <Skeleton variant="circular" width={16} height={16} sx={{ marginRight: '4px' }} />
              <Skeleton variant="text" width={110} height={12} />
            </StatusMessage>
            <StatusIcons>
              <Skeleton variant="circular" width={16} height={16} />
            </StatusIcons>
          </ListItemFooter>
        </ListItem>
      </ListItemHover>
    </ListItemWrapper>
  );
};
